export default {
  inserted: (el, binding) => {
    let focusEl = binding.value ? el.querySelector(binding.value) : el;
    setTimeout(() => {
      focusEl.focus();
    }, 50);
  }
};